import React from "react";
import { format } from "date-fns";
import "./style.scss";
import { getSessionTextFull } from "@utils/ticketUtils";

// re-format dates as "yyyy/mm/dd hh:mm:ss"
// to prevent safari issues
const cleanupDate = (str) => {
    // format yyyy/mm/dd instead of yyyy-mm-dd
    str = str.replace(/-/g, "/");
    // strip micro seconds
    if (str.indexOf(".") !== -1) {
        str = str.substring(0, str.indexOf("."));
    }
    return str;
};

const SessionDetails = ({ session }) => {
    const rawSessionDate = session?.session_date?.date ?? session?.session_date;
    const sessionDate = typeof rawSessionDate === "string" ? cleanupDate(rawSessionDate) : rawSessionDate;

    // Without a guard a missing session date formats as the epoch (1st Jan 1970).
    const parsedDate = sessionDate ? new Date(sessionDate) : null;
    const hasValidDate = parsedDate && !Number.isNaN(parsedDate.getTime());
    const formattedDate = hasValidDate ? format(parsedDate, "do MMM") : "";
    const formattedTime = hasValidDate ? format(parsedDate, "h:mm a") : "";
    const movieTitle = session?.movie_title ? <h2 className="session-details__heading">{session?.movie_title}</h2> : null;

    const sessionText = getSessionTextFull(session);
    const displayText = typeof sessionText === "string" ? sessionText : sessionText?.long || "";

    return (
        <div className="session-details">
            {movieTitle}
            <ul className="session-details__list">
                <li className="session-details__item">
                    {formattedTime ? `${formattedTime}, ` : ""}{displayText}
                </li>
                {formattedDate ? (
                    <li className="session-details__item">
                        {formattedDate}
                    </li>
                ) : null}
                <li className="session-details__item">
                    {session?.venue_name}
                </li>
                <li className="session-details__item">
                    {session?.venue_address},<br />{session?.venue_suburb}, {session?.venue_state?.toUpperCase()}
                </li>
            </ul>
        </div>
    );
};

export default SessionDetails;
